<section
  class="pz-personalized-banner hmf-display-flex hmf-flex-column hmf-flex-l-row"
  [class.pz-personalized-banner--small]="banner().bannerSize === 'small'"
  [class.pz-personalized-banner--medium]="banner().bannerSize !== 'small'"
  [style.background-color]="banner().backgroundColor || null"
  [style.--pz-banner-text-color]="banner().textColor || null"
  [attr.aria-label]="banner().title">

	<!-- Banner image -->
  @if (banner().urlImage) {
    <div class="pz-personalized-banner__image-wrapper hmf-position-relative hmf-flex-shrink-none">
      <img
        class="pz-personalized-banner__image"
        [ngSrc]="banner().urlImage"
        [alt]="banner().title"
        fill />
    </div>
  }

  <!-- Content -->
  <div class="pz-personalized-banner__content hmf-display-flex hmf-flex-column hmf-align-items-center hmf-justify-content-center hmf-text-align-center">
    @if (banner().title) {
      <p class="pz-personalized-banner__title hmf-header-bold-s hmf-m-0 hmf-truncate-multiline-2">
        {{ banner().title }}
      </p>
    }

    @if (banner().subtitle) {
      <p class="pz-personalized-banner__subtitle hmf-body-m hmf-m-0 hmf-mt-xxs hmf-truncate-multiline-2">
        {{ banner().subtitle }}
      </p>
    }

    @if (banner().primaryCta?.text || banner().secondaryCta?.text) {
      <div class="pz-personalized-banner__ctas hmf-mt-s hmf-display-flex hmf-gap-s hmf-flex-wrap hmf-justify-content-center">
        @if (banner().bannerType === 'standard') {
          @if (banner().primaryCta?.text) {
            <a
              hmf-text-link
              variant="primary"
              class="pz-personalized-banner__cta-link"
              size="large"
              [linkURL]="banner().primaryCta?.link"
              [dataEm]="banner().primaryCta?.identifier"
              [ariaLabel]="banner().primaryCta?.text">
              {{ banner().primaryCta?.text }}
            </a>
          }
          @if (banner().secondaryCta?.text) {
            <a
              hmf-text-link
              variant="primary"
              class="pz-personalized-banner__cta-link"
              size="large"
              [linkURL]="banner().secondaryCta?.link"
              [dataEm]="banner().secondaryCta?.identifier"
              [ariaLabel]="banner().secondaryCta?.text">
              {{ banner().secondaryCta?.text }}
            </a>
          }
        } @else {
          <button
            hmf-action-text
            variant="primary"
            class="pz-personalized-banner__cta-filter"
            size="large"
            type="button"
            [attr.aria-label]="banner().primaryCta?.text"
            (click)="handleFilterCta()">
            {{ banner().primaryCta?.text }}
          </button>
        }
      </div>
    }
  </div>
</section>
